import apiClient from './api';

const studentService = {
  // Get all students with optional filters
  getStudents: async (params = {}) => {
    try {
      const response = await apiClient.get('/students/', { params });
      return response.data;
    } catch (error) {
      console.error('Error in getStudents:', error);
      throw error;
    }
  },

  // Get pending registrations
  getPendingRegistrations: async () => {
    try {
      const response = await apiClient.get('/students/pending');
      return response.data;
    } catch (error) {
      console.error('Error in getPendingRegistrations:', error);
      throw error;
    }
  },

  // Approve student registration
  approveStudent: async (id, notes = '') => {
    const response = await apiClient.post(`/students/${id}/approve`, { notes });
    return response.data;
  },

  // Reject student registration
  rejectStudent: async (id, reason) => {
    const response = await apiClient.post(`/students/${id}/reject`, { reason });
    return response.data;
  },

  // Alias for approve registration (used by RegistrationApprovalsPage)
  approveRegistration: async (id, notes = '') => {
    const response = await apiClient.post(`/students/${id}/approve`, { notes });
    return response.data;
  },

  // Alias for reject registration (used by RegistrationApprovalsPage)
  rejectRegistration: async (id, reason) => {
    const response = await apiClient.post(`/students/${id}/reject`, { reason });
    return response.data;
  },

  // Get single student by ID
  getStudent: async (id) => {
    const response = await apiClient.get(`/students/${id}`);
    return response.data;
  },

  // Create new student
  createStudent: async (data) => {
    const response = await apiClient.post('/students/', data);
    return response.data;
  },

  // Update student
  updateStudent: async (id, data) => {
    const response = await apiClient.put(`/students/${id}`, data);
    return response.data;
  },

  // Delete student
  deleteStudent: async (id) => {
    const response = await apiClient.delete(`/students/${id}`);
    return response.data;
  },

  // Get student's hostel details
  getStudentHostel: async (id) => {
    const response = await apiClient.get(`/students/${id}/hostel`);
    return response.data;
  },

  // Get student's mess details
  getStudentMess: async (id) => {
    const response = await apiClient.get(`/students/${id}/mess`);
    return response.data;
  },

  // Get student's payments
  getStudentPayments: async (id) => {
    const response = await apiClient.get(`/students/${id}/payments`);
    return response.data;
  },

  // Get student's agreements
  getStudentAgreements: async (id) => {
    const response = await apiClient.get(`/students/${id}/agreements`);
    return response.data;
  },

  // Admin upload student profile photo
  uploadStudentPhoto: async (id, imageData) => {
    const response = await apiClient.post(`/students/${id}/upload-photo`, { image: imageData });
    return response.data;
  },

  // Verify student documents
  verifyDocuments: async (id, verificationData) => {
    const response = await apiClient.post(`/students/${id}/verify-documents`, verificationData);
    return response.data;
  },

  // Send verification report to student
  sendVerificationReport: async (id) => {
    const response = await apiClient.post(`/notifications/students/${id}/send-verification-report`, {});
    return response.data;
  },
};

export default studentService;
